import { useCallback, useState } from 'react'
import {
  OnResizeCallback,
  ResizePayload,
  useResizeDetector,
  UseResizeDetectorReturn,
} from 'react-resize-detector'

import { DEFAULT_HEIGHT } from './constants'

type Props = {
  defaultHeight?: number
}

type Return = {
  containerRef: UseResizeDetectorReturn<HTMLDivElement>['ref']
  editorHeight: number
  headerRef?: UseResizeDetectorReturn<HTMLDivElement>['ref']
}

export const useResizable = ({ defaultHeight }: Props): Return => {
  const [editorHeight, setEditorHeight] = useState<number>(defaultHeight ?? DEFAULT_HEIGHT)

  const { height: heightHeader, ref: headerRef } = useResizeDetector<HTMLDivElement>()

  const { ref: containerRef } = useResizeDetector<HTMLDivElement>({
    onResize: useCallback<OnResizeCallback>(
      ({ height }: ResizePayload): void => {
        if (height !== null) {
          setEditorHeight(height - (heightHeader ?? 0))
        }
      },
      [heightHeader],
    ),
    skipOnMount: true,
  })

  return {
    containerRef,
    editorHeight,
    headerRef,
  }
}
